window.addEventListener('DOMContentLoaded', () => {
  const els = document.querySelectorAll('.glide')
  els.forEach(el => {
    const glide = new Glide(el, {
      // type: 'carousel',
      gap: 0,
      rewind: false,
      animationDuration: 400,
      rewindDuration: 400,
    })

    glide.on('run', (ctx) => {
      const slides = glide.selector.querySelectorAll('.glide__slides .glide__slide')
      slides.forEach(slide => slide.style.opacity = 0)
      slides[glide.index].style.opacity = 1
    })

    glide.on('run.after', () => {
      const ghosts = glide.selector.querySelectorAll('.glide__ghost-slides .glide__slide')
      ghosts.forEach(ghost => ghost.style.opacity = 0)
      ghosts[glide.index].style.opacity = 1
    })

    glide.on('swipe.start', () => {
      const slides = glide.selector.querySelectorAll('.glide__slides .glide__slide')
      slides.forEach(slide => slide.style.opacity = 1)
      slides[glide.index].style.opacity = 0
    })

    glide.on(['mount.after'], () => {
      el.classList.add('glide--init')
    })

    glide.mount()
  })


})